import { objectEntries } from "~/utils/object-entries"

export const objectFilter = <ObjectType extends { [key: string]: any }>(
  obj: ObjectType,
  predicate: (entry: [keyof ObjectType, ObjectType[keyof ObjectType]]) => boolean
) => Object.fromEntries(objectEntries(obj).filter(predicate))
